import { IApiError } from '@/models/apiError.model';
import { IBaseLLMTemplate } from '@/models/llmTemplate.model';

export const SLICE_NAME = 'llmTemplateDetails';

export interface LLMTemplateDetailsState {
  template: IBaseLLMTemplate | null;
  isLoading: boolean;
  isSaving: boolean;
  error: IApiError | null;
}

export const initialState: LLMTemplateDetailsState = {
  template: null,
  isLoading: false,
  isSaving: false,
  error: null,
};
